import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import type { IndustryDataAvailabilityDate } from "app/pages/digital-marketing/ad-intelligence/common/data-availability/industryDataAvailability";
import { resolveDataAvailability } from "app/pages/digital-marketing/ad-intelligence/common/data-availability/industryDataAvailability";

import { useIndustryQueryParams } from "./useIndustryQueryParams";

// Availability-aware wrapper around `useIndustryQueryParams`: clamps the request's
// start date to the endpoint's earliest supported date and tells the caller whether
// to render the availability notice and whether to skip the request entirely.
// No explicit return annotation — inferred so `params` keeps the precise
// (non-widened) types the underlying endpoint params expect.
export const useIndustryAvailabilityParams = (category: IFlattenedCategory, minDate: IndustryDataAvailabilityDate) => {
    const params = useIndustryQueryParams(category);
    const { from, isBeforeMinDate, isUnavailable } = resolveDataAvailability({
        from: params.from,
        to: params.to,
        minDate,
    });

    return {
        params: { ...params, from },
        availability: {
            minDate,
            isBeforeMinDate,
            isFullyUnavailable: isUnavailable,
        },
    };
};
